export default __webpack_public_path__ + "img/component-btn.75fe9b24.png";